import tenantConstants from '@constants';
import staticResponseConfig from './staticDynamicFieldsResponse.json';
import { buildDynamicFieldsResponse } from '../utils/dynamicFieldsResponse';
import { isLandCategorySlug } from './landCategory';

const DEFAULT_FIELD = {
  display: true,
  is_required: false,
  is_editable: true,
  destination_key: null,
  dynamic_field_options: [],
};

const resolveField = (fieldDef) => {
  const { sectionKey, optionsKey, ...rest } = fieldDef;
  return {
    ...DEFAULT_FIELD,
    ...rest,
    dynamic_section: staticResponseConfig.sections[sectionKey],
    dynamic_field_options: optionsKey ? staticResponseConfig.options[optionsKey] : [],
  };
};

const FLOOR_AND_BUILTUP_FIELD_KEYS = ['total_floors', 'floor_number', 'built_up_area'];

const SHARED_FIELDS = staticResponseConfig.sharedFields.map(resolveField);
const FIELDS_BY_LISTING_PURPOSE = {
  sale: [...staticResponseConfig.saleFields.map(resolveField), ...SHARED_FIELDS],
  rent: [...staticResponseConfig.rentFields.map(resolveField), ...SHARED_FIELDS],
};

export function getCommonStaticDynamicFieldsResponse(arg) {
  const dynamicFields = FIELDS_BY_LISTING_PURPOSE[arg?.listingPurposeKey] || [];
  // Completion status (Ready / Off-plan) shows only on sell listings when enabled, and
  // never on land listings. Land is detected by category slug (portable across tenants).
  const showCompletionStatus =
    tenantConstants.SHOW_COMPLETION_STATUS_FOR_SELL &&
    arg?.listingPurposeKey === 'sale' &&
    !isLandCategorySlug(arg?.categorySlug);
  const withCompletionStatus = showCompletionStatus
    ? dynamicFields
    : dynamicFields.filter((field) => field?.key_name !== 'completion_status');
  // Total Floors / Floor Number / Built-up Area are tenant-gated (currently Oman/Qatar/Bahrain
  // only) so they never leak into the shared common catalogue's other consumers (EG, Jordan, Zameen).
  const fields = tenantConstants.SHOW_FLOOR_AND_BUILTUP_FIELDS
    ? withCompletionStatus
    : withCompletionStatus.filter((field) => !FLOOR_AND_BUILTUP_FIELD_KEYS.includes(field?.key_name));
  return buildDynamicFieldsResponse(fields);
}
